/* Geek Vacuums design system behaviour: chat buttons, video facades, video playlists. Runs once per page. */
(function () {
  if (window.__gvds) return;
  window.__gvds = true;

  var coarse = function () { return matchMedia('(pointer:coarse)').matches; };

  function openChat() {
    var w = window, sc = document.querySelector('shopify-chat'),
      el = document.getElementById('ShopifyChat') || document.querySelector('inbox-online-store-chat');
    try { if (sc) { sc.open = true; return true; } } catch (e) {}
    try { if (w.Shopify && w.Shopify.chat && w.Shopify.chat.open) { w.Shopify.chat.open(); return true; } } catch (e) {}
    try { if (w.ShopifyChat && w.ShopifyChat.open) { w.ShopifyChat.open(); return true; } } catch (e) {}
    try {
      if (el) {
        var r = el.shadowRoot, b = r && (r.querySelector('button.chat-toggle') || r.querySelector('button[aria-label*="hat" i]') || r.querySelector('button'));
        if (b) { b.click(); return true; }
        el.click(); return true;
      }
    } catch (e) {}
    return false;
  }
  window.gvOpenChat = openChat;

  function embed(spec, title) {
    var p = spec.split(':'), src;
    if (p[0] === 'vimeo') src = 'https://player.vimeo.com/video/' + p[1] + '?autoplay=1&dnt=1&title=0&byline=0&portrait=0';
    else src = 'https://www.youtube-nocookie.com/embed/' + p[1] + '?autoplay=1&rel=0&modestbranding=1';
    var f = document.createElement('iframe');
    f.src = src;
    f.title = title || 'Video';
    f.allow = 'autoplay; fullscreen; picture-in-picture';
    f.allowFullscreen = true;
    return f;
  }

  function play(btn) {
    var holder = document.createElement('div');
    holder.className = btn.className;
    holder.setAttribute('style', btn.getAttribute('style') || '');
    holder.setAttribute('data-video', btn.getAttribute('data-video'));
    holder.appendChild(embed(btn.getAttribute('data-video'), btn.getAttribute('data-title')));
    btn.replaceWith(holder);
    return holder;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-chat]');
    if (t) {
      e.preventDefault();
      if (!openChat() && coarse()) location.href = 'tel:18333822886';
      return;
    }
    t = e.target.closest && e.target.closest('[data-tel]');
    if (t && !coarse()) { e.preventDefault(); return; }

    t = e.target.closest && e.target.closest('button.vid[data-video]');
    if (t) { e.preventDefault(); play(t); return; }

    /* Playlist item: load the demo into the section's main player */
    t = e.target.closest && e.target.closest('[data-demo]');
    if (t) {
      e.preventDefault();
      var wrap = t.closest('[data-videos]');
      var stage = wrap && wrap.querySelector('[data-stage]');
      if (!stage) return;
      var spec = t.getAttribute('data-demo'), title = t.getAttribute('data-title') || '';
      stage.innerHTML = '';
      var box = document.createElement('div');
      box.className = 'vid';
      box.appendChild(embed(spec, title));
      stage.appendChild(box);
      var h = wrap.querySelector('[data-now-title]'), d = wrap.querySelector('[data-now-desc]');
      if (h) h.textContent = title;
      if (d) d.textContent = t.getAttribute('data-desc') || '';
      Array.prototype.forEach.call(wrap.querySelectorAll('[data-demo]'), function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      var top = stage.getBoundingClientRect().top;
      if (top < 60 || top > innerHeight * 0.6) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
})();
